import { useState, useRef, useCallback } from 'react';
import { lookupPostalCode } from '../services/postal.service';
import type { AddressResult } from '../services/postal.service';

const DEBOUNCE_MS = 300;

export function usePostalLookup(): {
  lookup: (zipcode: string) => Promise<AddressResult | null>;
  loading: boolean;
} {
  const [loading, setLoading] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const lookup = useCallback(
    (zipcode: string): Promise<AddressResult | null> => {
      if (timerRef.current !== null) clearTimeout(timerRef.current);

      return new Promise((resolve) => {
        timerRef.current = setTimeout(async () => {
          setLoading(true);
          try {
            const result = await lookupPostalCode(zipcode);
            resolve(result);
          } finally {
            setLoading(false);
          }
        }, DEBOUNCE_MS);
      });
    },
    []
  );

  return { lookup, loading };
}
